<style>

.stars{
    display: grid;
    margin-top: 10px;
    align-items: center;
    justify-items: center;
}


</style>

<div class="container feedback" on:load="{ () => eventFeedback = true}">
<Dialog show="{eventFeedback}" title="How would you rate this event?" close="{false}" buttons="{ [ {text: 'Submit', callback: 'submit', disabled: false, }, {text: 'Skip', callback: 'skip', disabled: false, } ] }" on:submit="{submitFeedback}" on:skip="{ () => push('/events') }">
    <div class="stars">
    <Stars bind:stars='{stars}' readWrite={true}></Stars></div>
</Dialog>
</div>

<div>
<FeedbackPrompt></FeedbackPrompt>
</div>


<script>

import {push, pop, replace, location} from 'svelte-spa-router';
import Stars from '../components/Stars.svelte';
import Dialog from '../components/Dialog.svelte';
import FeedbackPrompt from '../components/FeedbackPrompt.svelte'

let eventFeedback = true;
let stars = 0;

function submitFeedback() {
    push('/eventfeedback2')
}

</script>